<div class="w-full grid grid-cols-4 gap-2 items-center">
  <div class="col-span-3">
    <mat-form-field class="w-full">
      <mat-label>Credit Card</mat-label>
      <mat-select [formControl]="formControl" [required]="field.props.required">
        @for (option of this.props?.options; track option?.value) {
          <mat-option [value]="option?.value">
            {{option?.label}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <button mat-button  class="w-full cta-main flex justify-center items-center" (click)="addNewCard()">
    <div class="flex justify-center items-center gap-1">
      <mat-icon class="text-white mr-0" [svgIcon]="'heroicons_outline:credit-card'"></mat-icon>
      <span class="text-sm xl:text-base">Add Card</span>
    </div>
  </button>
</div>